

/*
 *
 * Date: 2025
 * Description: List form component for adding or editing items, even handling deleting items or the whole list..
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Fragment, ReactElement } from "react";
import { Box , TextField , Paper , Grid , Typography, IconButton , Button, Icon, Tooltip, MenuItem } from "@mui/material";


//Interfaces
import { i_parts } from "../../interfaces/items.interface";
import { i_list_form } from "../../interfaces/display.interfaces";


//Components
import ViewPartCard from "../card/view.part.card";

//Icons
import ClearIcon from '@mui/icons-material/Clear';
import { DeleteForever } from "@mui/icons-material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

//Utils
import { timestampToDate } from "../../utils/utility";
import PaymentContainer from "../container/payment.container";


const ListForm = ( props : i_list_form ) : ReactElement => {
    const F = props.form;
    const E = props.errors;
    const handleField = ( event : React.ChangeEvent<HTMLInputElement> ) => {
        const { name, value } = event.target
        if(name === 'note'){
            props.setNote(value)
        }else{
            props.setForm({...F, [name] : value})
        }
    }
    const handleNote = () => {
        props.setNote('')
        props.setForm({...F, notes : [...F.notes, props.note]})
    }

    const killNote = (index : number) => {
        props.setForm({...F, notes : [...F.notes.slice(0, index),...F.notes.slice(index + 1)]})
    }
    const killPart = (index : i_parts) => {
        const newItems = F.items.filter((item : i_parts) => item._id!== index._id)
        props.setForm({...F, items : newItems})
    }
    return (
        <Box sx={{ maxWidth : '1400px' , marginLeft : 'auto' , marginRight : 'auto' , marginTop : '2vh'}}>
            {/* <Button sx={{ marginLeft : 2 , marginBottom : 2}} variant="contained" color={'secondary'} onClick={() => props.setDisplay('view')}> Go back </Button> */}
            {props.form._id === '' && 
                <Box sx={{ marginBottom : '5vh'}}>
                    <Typography variant="h4" sx={{ textAlign : 'center'}}>Create a new list..</Typography>
                </Box>
            }
            <Box sx={{ marginBottom : '4vh'}}>
                <IconButton onClick={() => props.setDisplay('view')} sx={{ float : 'left' , top : -40 }}><ArrowBackIcon sx={{ height : 30 , fontSize : 30}}/></IconButton>
            </Box>
            <Paper  elevation={2} sx={{ maxWidth : '1350px' , marginLeft : 'auto' , marginRight : 'auto' , padding : 4}}>
                    <Grid container spacing={2}>
                        {props.display === 'form' ?
                        <>
                        <Grid size={{ xs : 12}} sx={{ borderTop : '1px solid gray'}}>
                                <Box sx={{ width : '100%'}}>
                                    {props.form._id !== '' &&
                                        <Fragment>
                                            <Tooltip title={'Warning this will delete the order and all its history'}>
                                                <IconButton onClick={() => props.modalCallback('delete')} sx={{ float : 'right' , color : 'red'}}>
                                                    <DeleteForever sx={{ fontSize : 40}}></DeleteForever>
                                                </IconButton>
                                            </Tooltip>
                                            <Button variant="contained" sx={{ margin :2}} onClick={() => props.setSubDisplay('payment')}> Manage Payments </Button>
                                        </Fragment>
                                    }
                                    <Typography variant="h5" sx={{ textAlign : 'center' , padding : 1}}>Order informations</Typography>
                                </Box>
                            </Grid>
                            <Grid size={{ xs : 2}} sx={{ alignSelf : 'center'}} >
                                <Box >
                                    <Typography sx={{ textAlign : 'center'}}>Order number :</Typography>
                                </Box>
                            </Grid>
                            <Grid size = {{ xs: 10}}>
                                <Typography sx={{ fontSize : 20 , fontWeight : 800}}>{F.order_number}</Typography>
                            </Grid>
                                <Grid size={{ xs : 2}} sx={{ alignSelf : 'center'}} >
                                    <Box >
                                        <Typography sx={{ textAlign : 'center'}}>Po number :</Typography>
                                    </Box>
                                </Grid>
                                <Grid size = {{ xs: 10}}>
                                    <TextField type="text" sx={{}} error={E.po !== '' ? true : false} helperText={E.po} value={F.po} name={'po'} onChange={handleField} />
                                </Grid>
                                <Grid size={{ xs : 2}} sx={{ alignSelf : 'center'}} >
                                    <Box >
                                        <Typography sx={{ textAlign : 'center'}}>Customer notes :</Typography>
                                    </Box>
                                </Grid>
                                <Grid size = {{ xs: 10}}>
                                    <TextField type="text" multiline rows={2} sx={{ width : '100%' , maxWidth : '1000px'}} error={E.comment !== '' ? true : false} helperText={E.comment} value={F.comment} name={'comment'} onChange={handleField} />
                                </Grid>
                                {props.form._id !== '' &&
                                    <>
                                        <Grid size={{ xs : 2}} sx={{ alignSelf : 'center' }}>
                                            <Box >
                                                <Typography sx={{ textAlign : 'center'}}>Order date :</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid size = {{ xs: 10}}>
                                            <Typography sx={{ textDecoration : 'underline'}}>{timestampToDate(F.history[0].timestamp , 'long')}</Typography>
                                        </Grid>
                                        <Grid size={{ xs : 2}} sx={{ alignSelf : 'center' }}>
                                            <Box>
                                                <Typography sx={{ textAlign : 'center'}}>Order status :</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid size = {{ xs: 10}}>
                                            <TextField select sx={{ width : '250px'}} value={F.status} name={'status'} onChange={handleField}>
                                                <MenuItem value="pending">Pending</MenuItem>
                                                <MenuItem value="transit">Transit</MenuItem>
                                                <MenuItem value="payment pending">Payment pending</MenuItem>
                                                <MenuItem value="completed">Completed</MenuItem>
                                                <MenuItem value="cancelled">Cancelled</MenuItem>
                                            </TextField>
                                        </Grid>
                                    </>
                                }
                                
                                { props.form._id!== '' &&
                                    <>
                                        <Grid size={{ xs : 12}} sx={{ borderTop : '1px solid gray'}}>
                                            <Box sx={{ width : '100%'}}>
                                                <Typography variant="h5" sx={{ textAlign : 'center' , padding : 1}}>Ordered parts ({F.items.length})</Typography>
                                            </Box>
                                        </Grid>
                                        
                                        <Grid size={{ xs: 12 }}>
                                            {F.items.map((item : i_parts, index : number) => (
                                                <Grid container key={index}>
                                                    <Grid size={{xs : 11.5}}>
                                                        <ViewPartCard key={index} part={item} />
                                                    </Grid>
                                                    <Grid size={{xs : 0.5}}>
                                                        <IconButton onClick={() => killPart(item)}>
                                                            <ClearIcon />
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </>
                                }
                            <Grid size={{ xs : 12}} sx={{ borderTop : '1px solid gray'}}>
                                <Box sx={{ width : '100%'}}>
                                    <Typography variant="h5" sx={{ textAlign : 'center' , padding : 1}}>Notes for this order({F.notes.length})</Typography>
                                </Box>
                            </Grid>
                            {F.notes.map((note : string, index : number) => (
                                <Grid key={index} size={{ xs : 12}} >
                                    <Grid container sx={{ border : '1px solid gray' , padding : 0.5 }}>
                                        <Grid size={{ xs:11.5}} sx={{ alignSelf : 'center'}}>
                                            <Box>
                                                <Typography>{index + 1} - {note}</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid size={{ xs:0.5}}>
                                            <IconButton onClick={() => killNote(index)}>
                                                <ClearIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                
                                </Grid>
                            ))}
                            <Grid size={{ xs : 2}} sx={{ alignSelf : 'center' }}>
                                <Box>
                                    <Typography sx={{ textAlign : 'center'}}>Add a new note :</Typography>
                                </Box>
                            </Grid>
                            <Grid size = {{ xs: 10}}>
                                <TextField type="text" multiline rows={4} sx={{ width : '100%' , maxWidth : '1000px'}} error={props.note !== '' ? true : false} value={props.note} name={'note'} onChange={handleField} />
                            </Grid>
                            <Grid size={{ xs : 12}} sx={{ margin : 0 }}>
                                <Box sx={{ display : 'flex' , justifyContent : 'center'}}>
                                    <Button variant="contained" color="primary" onClick={() => handleNote()}>Save this note</Button>
                                </Box>
                            </Grid>
                        
                            <Grid size={{ xs : 12}} sx={{ margin : 0 , borderTop : '1px solid gray'}}>
                                <Box sx={{ display : 'flex' , justifyContent : 'center' , marginTop : '2vh'}}>
                                    <Button sx={{ fontSize : 20, marginRight : '1vh'}} variant="contained" color="primary" onClick={() => props.callback('update')}>Save changes</Button>
                                </Box>
                            </Grid>
                            </>
                            :
                            <>
                                <Grid size={{ xs : 12}} sx={{ margin : 3 }}>
                                    <PaymentContainer history={F.history} payments={F.payments} callback={props.subCallback} goBack={() => props.setSubDisplay('form')}/>
                                </Grid>
                            </>
                        }
                    </Grid>
            </Paper>
        </Box>
    )
}

export default ListForm;